import * as React from 'react'

import { LoginComponent } from '../../components/OAuth2/Login'

interface LoginProps {}

export class Login extends React.Component<LoginProps, any> {
  //TODO find how to set dynamically the activated route
  render() {
    return <LoginComponent activatedRoute="/"/>
  }
}
